import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import MarketingSales from "@/pages/MarketingSales";

export const Route = createFileRoute("/pl/octopus")({
  head: () => routeHead('AGAPE Octopus — Silnik sprzedaży B2B', META_DESCRIPTIONS.octopus.pl, '/pl/octopus'),
  component: MarketingSales,
});
